import { TaxonomyFormPage } from '../taxonomy/TaxonomyFormPage.js';

export function CarBrandFormPage() {
  return (
    <TaxonomyFormPage
      config={{
        title: 'Brand',
        apiPath: '/car-brands',
        basePath: '/car-brands',
        resource: 'carBrand',
        fields: [],
      }}
    />
  );
}
